import { ISecurityItem } from "./PaymentSecurity";

export const data: ISecurityItem[] = [
    { icon: "lock", textLocale: "ssl" },
    { icon: "check-shield", textLocale: "secureCard" },
    { icon: "double-heart", textLocale: "guarantee" },
];
